import { CommonModule } from '@angular/common';
import { Component, HostListener, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ApplicationService } from 'app/services/application.service';
import { isEmptyObj } from 'app/shared/utils';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-select-officer-popup',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatIconModule,
        TranslateModule,
    ],
    templateUrl: './select-officer-popup.component.html',
})
export class SelectOfficerPopupComponent {
    brpOfficersList: any;
    branchDetails: any;
    initialBranchesList;
    getSelectedBRPBranches: any;
    getSelectedBrpOfficers: any;
    selectedBranchDetails: any;
    selectedBranchId: any;
    selectedBranchName: any;
    selectBranchError: string;
    selectOfficer: string;
    selectedOfficerDetails: any;
    selectedOfficerUserName: any;
    selectedOfficerName: any;
    selectedOfficerId: any;
    searchInput = '';
    stateOptions: [] = [];
    selectedState: string = '';
    isStateDropdownOpen: boolean = false;
    branchSuggestion: [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<SelectOfficerPopupComponent>,
        private translate: TranslateService,
        private applicationService: ApplicationService,
        private toastr: ToastrService,
    ) {}

    @HostListener('document:click', ['$event'])
    closeDropdown(event: MouseEvent): void {
            const target = event.target as HTMLElement;
            const dropdown = document.getElementById('stateDropdown');
            const branchSuggestionDropdown =
                document.getElementById('branchSuggestion');
            const searchInput = document.getElementById('searchInput');
    
            if (searchInput && searchInput.contains(target)) {
                return;
            }
    
            if (
                dropdown &&
                !dropdown.contains(target) &&
                this.isStateDropdownOpen
            ) {
                this.isStateDropdownOpen = false;
            }
    
            if (
                branchSuggestionDropdown &&
                !branchSuggestionDropdown.contains(target) &&
                this.branchSuggestion.length > 0
            ) {
                this.branchSuggestion = [];
            }
    }

    ngOnInit() {
        this.getTranslations();
        this.initialBranchesList = this.data.brpBranchesList;
        this.branchDetails = this.data.brpBranchesList;
        //get branches list if already selected to display
        this.getSelectedBRPBranches = this.data.selectedBrpBranches;
        this.selectedBranchName = this.getSelectedBRPBranches?.branchName;
        this.selectedBranchId = this.getSelectedBRPBranches?.branchId;
        this.branchDetails.forEach((element) => {
            this.brpOfficersList = element.officer;
        });
        //get officers list if already selected to display
        this.getSelectedBrpOfficers = this.data.selectedBrpOfficers;
        this.selectedOfficerUserName = this.getSelectedBrpOfficers?.officerUserName;
        this.selectedOfficerName = this.getSelectedBrpOfficers?.officerName;
        this.selectedOfficerId = this.getSelectedBrpOfficers?.officerId;
        this.getStatesList();
    }

    getTranslations() {
        this.translate
            .get('SELECT_BRANCH.PLEASE_SELECT_OFFICER_TO_CONTINUE')
            .subscribe((data: string) => {
                this.selectOfficer = data;
            });
        this.translate
            .get('SELECT_BRANCH.PLEASE_SELECT_BRANCH_TO_CONTINUE')
            .subscribe((data: string) => {
                this.selectBranchError = data;
            });
    }

    onSelectBranch(item) {
        this.selectedBranchDetails = item;
        this.selectedBranchName = item.branchName;
        this.selectedBranchId = item.branchId;

        this.selectedOfficerDetails = null;
        this.selectedOfficerId = null;
        this.selectedOfficerName = null;
        this.selectedOfficerUserName = null;
        this.getSelectedBrpOfficers = null;
    }

    onSelectOfficer(item) {
        this.selectedOfficerDetails = item;
        this.selectedOfficerName = item.officerName;
        this.selectedOfficerUserName = item.officerUserName;
        this.selectedOfficerId = item.officerId;
    }

    onSearchBranch(searchInput: string) {
        if (!searchInput) {
            this.branchDetails = this.initialBranchesList;
            return;
        }

        //search by city or postcode
        const filteredBranches = this.filterBranches(searchInput);
        this.branchDetails = filteredBranches;
        this.branchSuggestion = filteredBranches;
        this.isStateDropdownOpen = false;
        this.selectedState = null;
    }

    filterBranches(searchText: string) {
        return this.initialBranchesList.filter(
            (branch) =>
                branch.city.toLowerCase().includes(searchText.toLowerCase()) ||
                branch.ptc.toLowerCase().includes(searchText.toLowerCase())
        );
    }
    
    selectAutoSuggestion(branch: any) {
        this.searchInput = `${branch.ptc}, ${branch.city}`;
        this.branchDetails = this.initialBranchesList.filter(
            (b) =>
                b.city.toLowerCase() === branch.city.toLowerCase() &&
                b.ptc.toLowerCase() === branch.ptc.toLowerCase()
        );
        this.branchSuggestion = [];
    }

    highlightText(text: string, search: string): string {
        if (!search) return text;
        const pattern = search
            .replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
            .split(' ')
            .filter((t) => t.length > 0)
            .join('|');
        const regex = new RegExp(pattern, 'gi');
        return text.replace(
            regex,
            (match) => `<span class="tw-text-[#003A70]">${match}</span>`
        );
    }

    clearSearchInput() {
        this.searchInput = '';
        this.branchDetails = this.initialBranchesList;
    }

    onKeyPress(event: KeyboardEvent) {
        if (event.key === 'Enter' || event.key === 'Tab') {
            this.branchSuggestion = [];
            const searchInput = document.getElementById(
                'searchInput'
            ) as HTMLInputElement;
            if (searchInput) {
                searchInput.blur();
            }
        }
    }

    onFocusSearchInput() {
        if (this.searchInput) {
            this.branchSuggestion = this.filterBranches(this.searchInput);
        }
    }

    getStatesList() {
        this.applicationService.getStates().subscribe({
            next: (res) => {
                this.stateOptions = res.states;
            },
            error: (err) => { },
        });
    }

    onStateChange(event: Event): void {
        const selectedState = (event.target as HTMLSelectElement).value;
        this.branchDetails = selectedState
            ? this.initialBranchesList.filter(
                  (branch) => branch.state === selectedState
              )
            : this.initialBranchesList;
    }

    selectState(state: string): void {
        if (this.selectedState === state) {
            this.resetState();
        } else {
            this.selectedState = state;
            const customEvent = {
                target: { value: state },
            } as unknown as Event;
            this.onStateChange(customEvent);
        }
        this.isStateDropdownOpen = false;
        this.searchInput = '';
    }

    resetState(): void {
        this.selectedState = null;
        this.branchDetails = this.initialBranchesList;
        this.isStateDropdownOpen = false;
        this.searchInput = '';
    }

    toggleDropdown(event: MouseEvent) {
        event.stopPropagation();
        this.isStateDropdownOpen = !this.isStateDropdownOpen;
    }

    onSubmit() {
        let preSelectedBranches = isEmptyObj(this.getSelectedBRPBranches);
        let isSelectedBranchDetails = isEmptyObj(this.selectedBranchDetails);
        if (isSelectedBranchDetails && preSelectedBranches) {
            this.toastr.error(this.selectBranchError);
            return;
        }
        let preSelectedOfficers = isEmptyObj(this.getSelectedBrpOfficers);
        let isSelectedOfficerDetails = isEmptyObj(this.selectedOfficerDetails);
        if (isSelectedOfficerDetails && preSelectedOfficers) {
            this.toastr.error(this.selectOfficer);
            return;
        }
        this.dialogRef.close({
            selectedBrpBranches: this.selectedBranchDetails ? this.selectedBranchDetails : this.getSelectedBRPBranches,
            selectedBrpOfficers: this.selectedOfficerDetails ? this.selectedOfficerDetails : this.getSelectedBrpOfficers,
        });
    }
}
